import React from "react";
import { FiRotateCcw } from "react-icons/fi";
import { useColumnResizeContext } from "../../context/ColumnResizeContext";
import { ResetButton } from "./styles";

/**
 * Botao circular para restaurar todas as larguras de coluna ao padrao.
 * Desabilitado quando nao ha customizacoes.
 */
export default function ResetColumnsButton({ title = "Restaurar larguras de colunas" }) {
  const ctx = useColumnResizeContext();
  if (!ctx) return null;
  const disabled = !ctx.isCustomized;
  return (
    <ResetButton
      type="button"
      onClick={ctx.resetAll}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      <FiRotateCcw size={14} />
    </ResetButton>
  );
}
